import React, { useEffect } from 'react';
import styled, { css } from 'styled-components';
import { Loader } from './Loader';

const StyledListingLoader = styled.div`
  ${({ theme: { iconSizes } }) => {
    const height = iconSizes.extraLarge.split(' ')[1];
    return css`
      /* position: absolute;
      z-index: 9999999;
      left: 0;
      right: 0;

      top: ${height};
      height: ${height}; */
    `;
  }};
`;

export const ListingLoader = () => {

  return (
    <StyledListingLoader>
      <Loader centered />
    </StyledListingLoader>
  );
};
